import { isValidValue, setFormFieldValue } from "./FormHelper"


export const truncateString = (value, length) => {
    const isValid = isValidValue(value);
    if (isValid === false)
        return null;

    const formattedValue = value?.toString()?.length > length ? value?.toString()?.substring(0, length) + '...' : setFormFieldValue(value);
    return formattedValue;
};

export const getLowerCaseString = (value) => {
    const isValid = isValidValue(value);
    if (isValid === false)
        return null;

    const formattedValue = value?.toString()?.toLowerCase();
    return formattedValue;
};

export const getUpperCaseString = (value) => {
    const isValid = isValidValue(value);
    if (isValid === false)
        return null;

    const formattedValue = value?.toString()?.toUpperCase();
    return formattedValue;
};

export const getCapitalizedString = (value) => {
    const isValid = isValidValue(value);
    if (isValid === false)
        return null;

    const firstChar = value?.toString()?.charAt(0)?.toUpperCase();
    const remainingChars = value?.toString()?.slice(1);
    const formattedValue = firstChar + remainingChars;
    return formattedValue;
};